/* 
  If you're having knowledge problems I feel bad for you son,
  I got 99 problems but providing proper documentation through comments ain't one
*/
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Center, Select, Stack, Group } from "@mantine/core";
import useLoadBalancer from "../hooks/MistLoadBalancer";
import Player from "../components/Players/Player";
import StreamCrafter from "../components/StreamCrafter/StreamCrafter";

// Hardcoded stream name as configured in MistServer
// used as the base for wildcard streams
const baseStream = "live";

export default function BroadcasterPage(props) {
  const [selectedAddress, setAddress] = useState(
    Cookies.get("selectedTranscoder") || ""
  );
  const selectTranscoder = (addr) => {
    if (addr != selectedAddress) {
      Cookies.set("selectedTranscoder", addr);
      setAddress(addr);
    }
  };
  const [searchAddress, setSearch] = useState(selectedAddress);
  const thisTranscoders = props.transcoderInfo;
  // Refresh searchAddress if the selected transcoder changes
  useEffect(() => {
    if (searchAddress != selectedAddress) {
      setSearch(selectedAddress);
    }
  }, [selectedAddress]);
  // Retrieve info object of selected transcoder and fill data for search box
  let thisSearchData = [];
  let thisInfo = null;
  for (var idx = 0; idx < thisTranscoders.length; idx++) {
    const transcoder = thisTranscoders[idx];
    if (!transcoder.capacitySum) {
      continue;
    }
    if (transcoder.address == selectedAddress) {
      thisInfo = transcoder;
    }
    for (const region of transcoder.regions) {
      if (!region.capacity) {
        continue;
      }
      thisSearchData.push({
        value: transcoder.address,
        label: transcoder.address,
        group: region.orchestratorName,
        key: transcoder.address + region.orchestratorName,
      });
    }
  }
  // Amount of media previews to render at once in the bottom carousel
  const [carouselElements, setElements] = useState(6);
  var streamid = selectedAddress || "";
  if (streamid == "") {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < 8) {
      streamid += characters.charAt(
        Math.floor(Math.random() * charactersLength)
      );
      counter += 1;
    }
  }
  const streamName = baseStream + "+hint-" + streamid;
  // Get ingest node and stats
  const [bestHost, sourceLocation, loadBalancerInfo] = useLoadBalancer({
    streamName,
  });
  // Hide the player completely while the stream is inactive
  const renderPlayer = sourceLocation != "" && bestHost != "";

  // Set the amount of carousel items based on window width
  useEffect(() => {
    const handleWindowResize = () => {
      let carouselItems = Math.floor(window.innerWidth / 300);
      if (carouselItems < 2) {
        carouselItems = 2;
      }
      if (carouselItems != carouselElements) {
        setElements(carouselItems);
      }
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  // Only renders the title bar if true
  const [hidePlayer, setHidePlayer] = useState(false);
  // Use the canvas player or Mist player
  const [useMistPlayer, setMistPlayer] = useState(true);

  // Render different buttons based on the state
  let showHideButton;
  let switchPlayerButton;
  let shareButton;
  showHideButton = (
    <a className="headerLink" onClick={() => setHidePlayer(true)}>
      hide
    </a>
  );
  if (hidePlayer) {
    showHideButton = (
      <a className="headerLink" onClick={() => setHidePlayer(false)}>
        show
      </a>
    );
  }
  switchPlayerButton = (
    <a
      className="headerLink"
      onClick={() => {
        setMistPlayer(!useMistPlayer);
      }}
    >
      switch player
    </a>
  );

  // Render a direct link to view on the MistServer edge node
  if (props.link && props.link != "") {
    shareButton = (
      <a
        href={props.link}
        target="_blank"
        className="headerLink"
        style={{ cursor: "alias" }}
      >
        Share
      </a>
    );
  }

  // Display which player is loaded in the header
  let titleString = "player";
  if (!props.hidePlayer) {
    titleString += useMistPlayer ? " (MistMetaPlayer)" : " (native canvas)";
  }
  if (!renderPlayer) {
    showHideButton = <p>&nbsp;</p>;
    switchPlayerButton = <p>&nbsp;</p>;
    shareButton = <p>&nbsp;</p>;
    titleString = <p>&nbsp;</p>;
  }

  let widthOverride = "100vw";
  if (renderPlayer && !hidePlayer) {
    widthOverride = "50vw";
  }

  return (
    <Stack spacing={"28px"}>
      <Center>
        <Select
          data={thisSearchData}
          label="Select Transcoder"
          placeholder="ETH address"
          transition="pop-top-right"
          description="Note: if the selected transcoder is not connected to your local region, the job is sent to another transcoder"
          transitionDuration={80}
          transitionTimingFunction="ease"
          value={selectedAddress}
          onChange={selectTranscoder}
          onSearchChange={setSearch}
          searchValue={searchAddress}
          nothingFound="No Transcoders found"
          maxDropdownHeight={400}
          searchable
          radius="xs"
          sx={{ width: "400px" }}
        />
      </Center>
      {renderPlayer ? (
        <Center>
          <Group position="apart" spacing={24} grow sx={{ height: "100%" }}>
            <Group
              spacing={24}
              sx={{ paddingLeft: "24px", flexWrap: "nowrap" }}
            >
              {/* {shareButton} */}
              {showHideButton}
              {titleString}
              {switchPlayerButton}
            </Group>
          </Group>
        </Center>
      ) : null}
      <div className="flex-parent">
        <div
          className="container"
          style={{
            width: widthOverride,
            maxWidth: widthOverride,
            minWidth: widthOverride,
            minHeight: "50vh",
          }}
        >
          <StreamCrafter
            targetOverride={
              "wss://" + bestHost + "/view" + "/webrtc" + "/" + streamName
            }
            maxPushes={1}
            carouselItems={carouselElements}
          />
        </div>
        {renderPlayer != "" ? (
          <div
            className="container"
            style={{
              width: widthOverride,
              maxWidth: widthOverride,
              minWidth: widthOverride,
              minHeight: "50vh",
            }}
          >
            <Player
              streamName={streamName}
              host={bestHost}
              path={"/view/"}
              link={
                `${window.location.protocol}//${window.location.host}` +
                "/view/" +
                streamid
              }
              useMistPlayer={useMistPlayer}
              hidePlayer={hidePlayer}
            />
          </div>
        ) : null}
      </div>
    </Stack>
  );
}
